import axios from "axios";
import { parseJwt } from "../../Utility/TokenUtility";
import config from "../../Utility/ConfigUtility";
import LocalStorage, { Keys } from "../../Storage/LocalStorage";

const validateToken = (token) => {
  if (!token) return false;
  const { exp } = parseJwt(token);
  const currentTime = Math.floor(Date.now() / 1000);
  return exp && exp >= currentTime;
};

const path = config.redirectBaseUrl + '/' + config.subPath;

const addTokenToRequest = (configuration) => {
  const token = LocalStorage.get(Keys.CURRENT_ACCESS_TOKEN);

  if (!token || !validateToken(token)) {
    console.log('Token is invalid or expired. Redirecting to login...');
    window.localStorage.clear();
    window.location.href = path;
    return Promise.reject('Invalid token');
  }

  configuration.headers['Authorization'] = `Bearer ${token}`;

  const chargeCodeInfo = LocalStorage.get(Keys.CHARGE_CODE_INFORMATION);
  const chargeCodeValue = chargeCodeInfo?.chargeCode?.value;
  const headers = configuration.headers;
  if (
    chargeCodeValue &&
    headers.chargeCode == null &&
    headers.ChargeCode == null
  ) {
    headers['chargeCode'] = chargeCodeValue;
  }

  return configuration;
};

axios.interceptors.request.use(addTokenToRequest, (error) => Promise.reject(error));

export { validateToken, addTokenToRequest };